import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import homeActions from "../../Redux/Home/action";
import NoImage from "../../assets/images/noImage.jpg";
import { LogEvent } from "../../utils/firebase";
import Pagination from "../../common/pagination";
import { headertitle } from "../helper";


const BlogList = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const { homeContent } = useSelector((state) => state.AuthReducer);
  const { homeBlogs } = useSelector((state) => state.AuthReducer);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  let [blogList, setBlogList] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const endOffset = itemOffset + itemsPerPage;

  const pageCount = Math.ceil(blogList?.length / itemsPerPage);

  const { currentLanguage } = useSelector((state) => state.commonReducer);

  const handlePageChange = (event) => {
    const newOffset = (event.selected * itemsPerPage) % blogList?.length;
    setItemOffset(newOffset);
    setCurrentPage(event?.selected);
    window.scrollTo({ top: 0 });
  };

  useEffect(() => {
    if (currentLanguage) {
      dispatch({
        type: homeActions.GET_HOME_CONTENTS,
        payload: {
          language_code: currentLanguage,
          type: headertitle.BLOG,
        },
      });
    }
  }, [dispatch, currentLanguage]);



  useEffect(() => {
    if (Array.isArray(homeBlogs) && homeBlogs.length > 0) {

      const blogs = homeBlogs
        .filter((item) =>
          item.language?.some(
            (lang) => lang.language_code === currentLanguage
          )
        )
        .sort(
          (a, b) =>
            new Date(b.created_at) - new Date(a.created_at)
        );

      setBlogList(blogs);

    } else {
      setBlogList([]);
    }

  }, [homeBlogs, currentLanguage]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(blogList.slice(itemOffset, endOffset));
  }, [itemOffset, blogList, itemsPerPage]);

  return (
    <>
      <Container className="my-5">
        <div className="mb-4">
          <div className="page_heading_div_cls">{t("Blogs")}</div>
        </div>

        <div className="container">
          {currentItems?.length > 0 ? (
            <Row className="justify-content-center">

              {currentItems?.map((blog) => (
                <Col key={blog.id} md={10} className="mb-4">
                  <Card className="blog-card-section">
                    <Row noGutters>
                      <Col md={4}>
                        <Card.Img
                          variant="top"
                          src={blog.img_url || NoImage}
                          alt={`Blog ${blog.id}`}
                          className="blog-image"
                        />
                      </Col>
                      <Col md={8}>
                        <Card.Body className="blog-page-card-body">
                          <a
                            href={blog.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <h5 className="mb-3 blog-title">
                              {
                                blog?.language?.find(
                                  (lang) =>
                                    lang.language_code === currentLanguage
                                )?.title || blog.title
                              }

                            </h5>
                            <p
                              className="text-center mt-3"
                              style={{ color: "#232c63" }}
                            >
                              {t("Posted On")}: {formatDate(blog.created_at)}
                            </p>
                          </a>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="h5 my-5 text-center">{t("No Data Found")}</div>
          )}

          {pageCount > 1 && currentItems?.length > 1 && (
            <div className="mt-4">
              <Pagination
                pageCount={pageCount}
                onPageChange={handlePageChange}
                currentPage={currentPage}
              />
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default BlogList;
